/* eslint-disable object-shorthand */
import React, { memo, useEffect, useState } from 'react';
import ComboCharts from './comboCharts';
import { deepCopy } from '@utils/common';
import { Loading, ExpandButton } from '@components';
import D_Number from '@utils/number';
import D_Currency from '@utils/currency';
// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';

const commonOption = {
  styledMode: true,
  title: {
    text: '',
    align: 'left',
    style: {
      color: '#999999',
      fontSize: '1.2rem',
      fontFamily: 'Helvetica Neue,Arial !important',
    },
  },
  chart: {
    type: 'pie',
    style: {
      fontFamily: 'Helvetica Neue,Arial',
    },
  },
  series: [
    {
      data: [
        // {
        //     name: 'Chrome',
        //     y: 61.41,
        // }
      ],
      colors: [
        '#684794',
        '#5273E0',
        '#F77389',
        '#B57ACE',
        '#3BD5B0',
        '#4FA8F0',
        '#CDA8F0',
        '#F8A8CC',
        '#84E2D8',
        '#D0ECFF',
      ],
      borderWidth: '0px',
    },
  ],
  credits: {
    enabled: false,
  },
  tooltip: {
    backgroundColor: '#303030',
    borderWidth: '0px',
    shadow: false,
    style: {
      color: '#DBDBDB',
      fontSize: '1rem',
      lineHeight: '1.063rem',
      padding: 10,
      fontWeight: 'bold',
      fontFamily: 'Helvetica Neue,Arial !important',
    },
    formatter: function () {
      const { options, percentage } = this.point;
      return `
            <b style="font-size: 0.75rem; font-weight: 400,font-family:Helvetica Neue Regular">${
              options.name
            }</b>
            <br>
            <b style="font-size: 0.75rem; font-weight: 400,font-family:Helvetica Neue Regular">${
              options.currencySymbol
            }${D_Number.format(options.y)}</b>
            <br>
            <b style="font-size: 0.75rem; font-weight: 400,font-family:Helvetica Neue Regular">${percentage.toFixed(
              2,
            )}%</b>
            `;
    },
  },
  plotOptions: {
    column: {
      stacking: 'normal',
    },
    pie: {
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
    },
  },
  legend: {
    align: 'right',
    verticalAlign: 'middle',
    itemWidth: 154,
    margin: 40,
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 0,
    layout: 'vertical',
    itemMarginBottom: 20,
  },
};

function GeographicSegments({ data, resourceId }) {
  const [isLoading, setIsLoading] = useState(true);
  // 把两张图标的数据进行深拷贝并且组合成一个数组
  const comboChartData = [deepCopy(commonOption), deepCopy(commonOption)];
  // 要更新的整张图标数据
  const [refreshData, refreshComboChartData] = useState(comboChartData);
  const [expand, setExpand] = useState(false);

  const loopAndChangeData = (data) => {
    if (Array.isArray(data.gs)) {
      for (let i = 0, len = data.gs.length; i < len; i++) {
        comboChartData[i].title.text = data.gs[i].companyName;
        if (Array.isArray(data.gs[i].geographySegments)) {
          for (let j = 0; j < data.gs[i].geographySegments.length; j++) {
            // 向series中的data添加数据
            const currencySymbol = D_Currency.getCurrencySymbol(
              data.gs[i].geographySegments[j].currencyIsoCode,
            );
            const obj = {};
            obj.currencySymbol = currencySymbol;
            obj.name = data.gs[i].geographySegments[j].segmentName;
            obj.y = data.gs[i].geographySegments[j].value;
            comboChartData[i].series[0].data.push(obj);
          }
        }
      }
    }
    refreshComboChartData({ ...comboChartData });
    setIsLoading(false);
  };
  const expandCharts = () => {
    setExpand(!expand);
  };
  // fetch data
  const fetchSegmentsData = async () => {
    setIsLoading(true);
    loopAndChangeData(data);
  };
  useEffect(() => {
    fetchSegmentsData();
  }, []);

  return (
    <div className={`analysis-right-wrapper ${expand && 'full-screen'}`}>
      <div className="title full-screen-title expand-box">
        <div>Geographic Segments</div>
        {!isLoading && <ExpandButton onClick={expandCharts} />}
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <div
          className="geo-segments-fullscreen-wrapper"
          style={{ display: 'flex' }}
        >
          <ComboCharts data={refreshData} expand={expand} />
        </div>
      )}
    </div>
  );
}

export default memo(GeographicSegments);
